import { queryClient } from '@/utils/reactQueryClient';
import { createAgendaController } from '@saas/api-client';
import { globalAuthRequestFunction } from '../http/request';
import { makeQuery } from '../http/queryUtils';

const agendaController = createAgendaController(globalAuthRequestFunction);

const agendaKeys = {
	base: 'AGENDA',
	list: (params: Parameters<typeof agendaController.list>[0]) => [agendaKeys.base, 'list', params] as const,
};

const invalidate = {
	all: () => queryClient.invalidateQueries({ queryKey: [agendaKeys.base] }),
};

const useAgendaRange = makeQuery({
	queryFunction: agendaController.list,
	queryKeyFactory: (params) => [...agendaKeys.list(params)],
});

export const agendaService = {
	useAgendaRange,
	invalidate,
};
